"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefreshAuthTokens = exports.getInitialAuthTokens = exports.getAuthTokens = void 0;
const authUtils_1 = require("../authUtils");
const Fetch_1 = require("../../Fetch");
const Config_1 = require("../../Config");
const getAuthTokens = ({ grantType, authCode, codeVerifier, refreshToken }) => {
    const authUrl = `${(0, Config_1.getConfigValue)('AUTH_ENDPOINT')}/oauth/token`;
    return fetch(authUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            grant_type: grantType,
            code: authCode,
            client_id: (0, Config_1.getConfigValue)('AUTH_CLIENT_ID'),
            redirect_uri: (0, authUtils_1.getAuthRedirectUri)(),
            code_verifier: codeVerifier,
            refresh_token: refreshToken,
        }),
    }).then(response => (0, Fetch_1.validateResponse)(response, 'get'))
        .then(response => response.json()).then(response => {
        console.log("return getAuthTokens", response);
        return response;
    });
};
exports.getAuthTokens = getAuthTokens;
const getInitialAuthTokens = ({ authCode, codeVerifier }) => {
    return (0, exports.getAuthTokens)({
        authCode,
        codeVerifier,
        grantType: 'authorization_code'
    });
};
exports.getInitialAuthTokens = getInitialAuthTokens;
const getRefreshAuthTokens = ({ refreshToken }) => {
    return (0, exports.getAuthTokens)({
        refreshToken,
        grantType: 'refresh_token'
    });
};
exports.getRefreshAuthTokens = getRefreshAuthTokens;
